























































































































































import IcbcApp from "jhm_icbc";
import { getOrderList, payOrderICBCWXMini } from "@/utils/httpUtils";
import { hiddenLoading, showLoading } from "@/utils/loading";
import { initUserInfoByUrl } from "@/utils/userInfoByUrl";
import { apiGet, icbcAppPay } from "jhm_api_ts";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { btnClick, productStage } from "@/utils/analysysAgent";

import { getLocalStorage } from "@/utils/localStorage";
@Component
export default class Coupon extends Vue {
  @State("pid") public pid?: string;
  @State("aid") public aid?: string;
  @State("aid_jqhd") public aid_jqhd?: string;

  activeIndex: any = this.$route.query.type || "0"; // 默认待支付
  token = this.$route.query.token;
  order_id = this.$route.query.order_id || "";
  preActiveIndex: any = this.activeIndex;
  list: any = [];
  isShowMoreButton = true;
  orderStaus: any = [
    { name: "全部", id: 0 },
    { name: "待付款", id: 1 },
    { name: "已购买", id: 2 },
    { name: "退款", id: 3 },
  ];
  get filterList() {
    return this.list.filter((item: any) => {
      if (this.activeIndex == 0) {
        return true;
      } else if (this.activeIndex == 1) {
        // 未支付订单
        return item.pay_state == 0;
      } else if (this.activeIndex == 2) {
        // 已购买
        return item.pay_state == 1 && item.state != 3 && item.state != 4;
      } else if (this.activeIndex == 3) {
        // 退款
        return item.pay_state == 1 && (item.state == 3 || item.state == 4);
      }
      return false;
    });
  }

  get isApp() {
    return IcbcApp.isICBCApp();
  }

  async mounted() {
    let res = this.orderStaus.find((el: any) => el.id == this.activeIndex);
    btnClick(res.name, "顶部tab");

    //从app直接跳转到订单页的情况
    initUserInfoByUrl(this.$route.query);
    this.initTabCheckedByOrderId();

    if (this.activeIndex == "1") {
      showLoading();
      await this.getWaitPayOrderList();
      hiddenLoading();
    } else {
      showLoading();
      await this.getAllOrderList();
      hiddenLoading();
    }
  }

  /**
   * @Description: Tab默认选择项根据url中是否有订单id
   */
  initTabCheckedByOrderId() {
    //如果url中有order_id则tab选中全部
    if (this.order_id) {
      this.activeIndex = "0";
    }
  }

  /**
   * 处理tab选中改变
   * @param currentIndex 当前tab选中项
   */
  async handleTabChange(currentIndex: string, val: any) {
    btnClick(val, "顶部tab");
    if (currentIndex == "1") {
      showLoading();
      await this.getWaitPayOrderList();
      hiddenLoading();
    } else if (this.preActiveIndex == "1") {
      if (this.isShowMoreButton == false) {
        await this.getMoreHistoryOrderList();
      } else {
        showLoading();
        await this.getAllOrderList();
        hiddenLoading();
      }
    }
    this.preActiveIndex = currentIndex;
  }
  /**
   * 获取待支付订单
   */
  async getWaitPayOrderList() {
    let data: any = { aid: this.aid };
    if (this.order_id) {
      data.order_id = this.order_id;
    }
    this.list = await getOrderList("waitPay", data);
  }
  /**
   * 获取全部订单
   */
  async getAllOrderList() {
    //全部订单里的待支付订单总共只能查询到一个，aids数组的第0项决定的是查询那个aid的待支付订单
    let data: any = { aids: [this.aid, this.aid_jqhd] };
    if (this.order_id) {
      data.order_id = this.order_id;
    }
    this.list = await getOrderList("all", data);
  }

  refundOrder(item: any) {
    btnClick("申请退款");
    this.$dialog
      .confirm({
        title: "温馨提示",
        message:
          "提交退款后，本次优惠名额视为已使用。退款申请审核通过后，将在5-7个工作日进行退款。",
      })
      .then(() => {
        btnClick("确认", "退款温馨提示");
        showLoading();
        apiGet("/apiv4/order/refund", { order_id: item.order_id }).then(
          (res: any) => {
            this.$toast.success(res.message);
            this.getAllOrderList();
          },
          (e) => {
            this.$toast.fail(e.message || e.info);
          }
        );
      });
  }

  async cancelOrder(item: any) {
    await this.$dialog.confirm({
      title: "温馨提示",
      message: "确定要取消此订单吗？",
    });
    showLoading();

    const result: any = await apiGet("/apiv4/order/refund", {
      order_id: item.order_id,
    }).catch((e) => {
      this.$toast.fail(e.message || e.info);
      throw e;
    });
    this.$toast.success(result.message);

    this.activeIndex == "1"
      ? await this.getWaitPayOrderList()
      : await this.getAllOrderList();
  }

  async payOrder(item: any) {
    productStage("立即支付", item);
    showLoading();

    if (!IcbcApp.isICBCApp()) {
      await payOrderICBCWXMini(
        item,
        "https://gdecard.jiahuaming.com/icbc/icbc_prtghd/#/home"
      ).catch((e) => {
        hiddenLoading();
        this.$dialog.alert({
          title: "温馨提示",
          message: e.message || e.info,
          confirmButtonText: "我知道了",
        });
      });
      hiddenLoading();
      return;
    }

    let payInfo = await apiGet("/apiv4/order/icbcAppPay", {
      order_id: item.order_id,
    }).catch((e) => {
      hiddenLoading();
      this.$toast.fail(e.message || e.info);
      return Promise.reject();
    });
    icbcAppPay(payInfo.data);
  }

  goStoreList(item: any) {
    btnClick("适用门店");
    this.$router.push({
      path: "/storeList",
      query: {
        gid: item.gid,
      },
    });
  }

  goProcedure(item: any) {
    btnClick("使用说明");
    this.$router.push({
      path: "/procedure",
      query: {
        ins_id: item.ins_id,
      },
    });
  }

  async seeOrder(item: any) {
    btnClick("我要使用");
    if (["2"].includes(String(item.code_type))) {
      await this.$dialog.confirm({
        title: "温馨提示",
        confirmButtonText: "继续查看",
        message: `<p style="font-size: 15px;color: #333333;margin:0 48px;">券码一经查看概不退换，确定继续查看吗？<p style="font-size: 13px;color: #666666;margin:11px 0 0">（为保护您的财产安全，查看券码时请您注意周围环境，防止他人盗用券码）</p></p>`,
      });
    }

    if (["2", "3"].includes(String(item.code_type))) {
      window.location.href = `/jhm/order_detail/?v=${new Date().getTime()}#/?pid=${
        item.pid
      }&aid=${item.aid}&gid=${item.gid}&order_id=${item.order_id}`;
    } else {
      window.location.href = `/code_details/?v=1#/?pid=${item.pid}&aid=${item.aid}&gid=${item.gid}&order_id=${item.order_id}`;
    }
  }

  goHome() {
    btnClick("去购券");
    this.$router.push("/home");
  }

  async getMoreHistoryOrderList() {
    btnClick("点击查询更多订单");
    showLoading();
    this.isShowMoreButton = false;
    //全部订单里的待支付订单总共只能查询到一个，aids数组的第0项决定的是查询那个aid的待支付订单
    this.list = await getOrderList("more", { aids: [this.aid, this.aid_jqhd] });
    hiddenLoading();
  }
}
